import { PaginationProps, Steps, Switch } from 'antd'
import { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Layout from '../../../../Layout'
import BreadcrumbBlockAdd from '../../../../components/BreadcrumbBlockAdd/BreadcrumbBlockAdd'
import '../CampaignSendsNotifications.scss'

import dayjs from 'dayjs'
import '../CampaignSendsNotifications.scss'
import InfoCreate, { ChildRef, IChannelListTmp, IChannelListTmpV9, SendStrategy, SendTimeType } from './Component/InfoCreate'
import PreView from './Component/PreView'
import useToast from '../../../../hook/useToast'
import useLoading from '../../../../hook/useLoading'
import { useSelector } from 'react-redux'
import { selectorInfoUser } from '../../../../store/slices/infoUserSlice'
import { getListCarCompany, getSLUnitByPermission, ISelectOption } from '../../../../api/selectOptions/selectOptionsApi'
import { getListNetwork, INetwork } from '../../../../api/network/networkApi'
import BreadcrumbBlock from '../../../../components/BreadcrumbBlock/BreadcrumbBlock'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { addCampaign, addCustomerCampaign, getListALLCustomerIdByGroupAndUser, getListCustomersByGroups, getListCustomersUnmatchedByGroups, IChannelList, IChannelListV9, IGroupCampaign, sendInstantlyCampaign } from '../../../../api/campaign/campaignApi'
import { FlattenedField } from '../../../CustomersV2/indexV2'
import { getListFieldsByCustomer, ICustomer, ListField } from '../../../../api/Customer_V2/customerApi_V2'
import { ColumnKey } from '../../../Customers/Tabs/CarListCardClone'
import { FIELDTYPE, NO_VIEW } from '../../../../services/data'
import { CONDITION, generateColumnsFromCodesAgGridReactGroup, ILastIdGroupCustomer, TypeConditionPreview } from '../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup'
import useDebounce from '../../../../hook/useDebounce'
import { useLocale } from 'antd/es/locale'
import { getListAllCustomer, getListConditionMatched, getListConditionUnMatched, getListCustomerByGroup, IConditionSV2, IVConditionFilterADD } from '../../../../api/groupCustomerV2/groupCustomerV2Api'
import { filterInfoOperator, initInfoOperator } from './Modal/ModalConditionCampaign'
import { CONDITIONGROUP } from '../../../Customers/CustomerGroup/Component/AddGroup/Component/PrivateGroup/AG_PrivateAutomatic'
import { use } from 'echarts'
import { AddType, ISelectedCustomer } from '../../../Customers/CustomerGroup/Component/EditGroup/EditGroup'
import { filterInfoOperatoToConditions } from '../../../../apiSync/customerGroup/customerGroupApi'
import { set } from 'lodash'
import { convertNationwideValueToTree_V2 } from '../../../../api/unit/unitApi'
import { convertDateValue, fommatSelectOption, getLastIdList } from '../../../../until'
import useThrottle from '../../../../hook/useThrottle'
import { toAddPayload } from '../../../Customers/CustomerGroup/Component/Modal/ModalAddAndEditCondition'
import { getListTarget, ITarget } from '../../../../api/target/targetApi'
import { selectorCategoryCarIds } from '../../../../store/slices/categoryCarSlice'
import { UserValue } from '../Component/SelectCustomSearch'
import { auto_icon, auto_icon_active, User, User_active } from '../../../../components/ExportImgFigma'
import { BATCH_SIZE } from '../../../../env'

dayjs.locale('vi');

type UserContextType = {
  step: number
  voucherTitle: UserValue | undefined
  ColumnsMapShow: ColumnKey[]
  dataFieldsActive: FlattenedField[]
  sLCategoryCar: ISelectOption[]
  sLNationwide: any[]
  sLTarget: ITarget[]
  setVoucherTitle: React.Dispatch<React.SetStateAction<UserValue | undefined>>
}

export const GroupContext = createContext<UserContextType | null>(null);

type FieldType = {
  title?: string;
  target?: string;
  customerGroup?: string,
  customer?: string,
  channel?: any;
  sendDate?: string;
  sendTime?: string;
};

export enum CampaignStep {
  SETUP_INFO = 0,
  PREVIEW = 1,
}

export interface IRowChannel {
  type: number
  brand: string
  car: string
  mauThongBao: string
}

export interface InfoCampaignTmp {
  id?: number
  title?: string
  code?: string
  description?: string
  adminId?: number
  targetId?: number
  type?: SendStrategy
  role?: SendTimeType
  auto?: number

  customerId?: number[]
  groupCustomerId?: IGroupCampaign[]
  channelList?: IChannelListTmpV9[]
  rows?: IRowChannel[]
  dateSend?: string
  timeSend?: string
  // sendTimeOption?: string

  sendBeforeUnit?: string
  sendHour?: string
  statsByChannel?: IStatsByChannel;
  phoneField?: string

  //tg tùy chỉnh
  sendEvent?: number
  sendInAdvance?: number


  // id voucher
  voucherId?: number

  groups?: IGroupCampaign[]
}

export interface IDataFilterGroupList {
  search?: string;
  listUnit?: number[]
  listCategoryCar?: number[]
}

export const dataDefaulFilterList: IDataFilterGroupList = {
  search: '',
  listUnit: [],
  listCategoryCar: [],
};

export interface IVConditionFilterCampaim {
  typeCondition: 0 | 1 | 2  //(0 and, 1 and or)
  conditions: IConditionSV2[]
}

export interface IStatsByChannel {
  [channelId: string]: IChannelStats;
}

export interface IChannelStats {
  success: number;
  failed: number;
  notSent: number;
}


const CreateAnnouncementCampaign = () => {

  useEffect(() => {

    gSLNetwork()
    gSLTarget()

    gListFieldsActive()
    // gSLFilterListPhoneCustomer()

    let unmounted = false;
    (async () => {
      const [resCar, resNationwide] = await Promise.all([getListCarCompany(), getSLUnitByPermission(unitTemp)]);
      if (!unmounted && resCar?.status) setSLCategoryCar(fommatSelectOption(resCar.data));
      if (!unmounted && resNationwide?.status) setSLNationwide(convertNationwideValueToTree_V2(resNationwide.data));
    })();

    return () => {
      setInfoCampaign(undefined)
      setIdCustomerLast({ condUnmatched: undefined, condMatched: undefined })

      setSqlTotal(undefined)
      setGroupCustomerSelected([])
      setSelectedIdCustomer([])
      setSelectedIdUnmatchedCustomers(new Set())

      setDataFilterMatchedCustomers(dataDefaulFilterList)
      setDataFilterUnmatchedCustomers(dataDefaulFilterList)
      setPaginationMatchedCustomers({ current: 1, pageSize: 30, total: 0 })
      setPaginationUnmatchedCustomers({ current: 1, pageSize: 30, total: 0 })

      setListMatchedCustomers([])
      setListUnmatchedCustomers([])
      setInfoIdGroupCustomer([])
    }
  }, [])


  const skipCondMatchedRef = useRef(false);
  const navigate = useNavigate()
  const location = useLocation();
  const pushToast = useToast();
  const pushLoading = useLoading()
  const { unitTemp, id } = useSelector(selectorInfoUser) // đợn vị dc chọn
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)



  const { isAutoCampaign } = location.state as { isAutoCampaign: boolean } || {}
  const [loadingTable, setLoadingTable] = useState(false)


  const childRef = useRef<ChildRef>(null);

  const [sLTarget, setSLTarget] = useState<ITarget[]>([])
  const [sLNetwork, setSLNetwork] = useState<INetwork[]>([])
  const [sLCategoryCar, setSLCategoryCar] = useState<ISelectOption[]>([]);
  const [sLNationwide, setSLNationwide] = useState<any>()


  const [step, setStep] = useState(CampaignStep.SETUP_INFO);

  const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])
  const [dataFieldsActive, setDataFieldsActive] = useState<FlattenedField[]>([])
  const [dataFieldsNoActive, setDataFieldsNoActive] = useState<ListField[]>([])

  const [infoCampaign, setInfoCampaign] = useState<InfoCampaignTmp>()
  const [idCustomerLast, setIdCustomerLast] = useState<{ condUnmatched?: number, condMatched?: number }>({ condUnmatched: undefined, condMatched: undefined });

  const [lastId, setLastId] = useState<ILastIdGroupCustomer>()
  const [voucherTitle, setVoucherTitle] = useState<UserValue>()
  const [sqlTotal, setSqlTotal] = useState<string>()

  const [groupCustomerSelected, setGroupCustomerSelected] = useState<IGroupCampaign[]>([])
  const [selectedIdCustomer, setSelectedIdCustomer] = useState<ISelectedCustomer[]>([]);
  const [selectedIdUnmatchedCustomers, setSelectedIdUnmatchedCustomers] = useState<Set<number>>(new Set());

  const [dataFilterMatchedCustomers, setDataFilterMatchedCustomers] = useState<IDataFilterGroupList>(dataDefaulFilterList)
  const [dataFilterUnmatchedCustomers, setDataFilterUnmatchedCustomers] = useState<IDataFilterGroupList>(dataDefaulFilterList)
  const [paginationMatchedCustomers, setPaginationMatchedCustomers] = useState({ current: 1, pageSize: 30, total: 0 });
  const [paginationUnmatchedCustomers, setPaginationUnmatchedCustomers] = useState({ current: 1, pageSize: 30, total: 0 });

  const [listMatchedCustomers, setListMatchedCustomers] = useState<ICustomer[]>([])
  const [listUnmatchedCustomers, setListUnmatchedCustomers] = useState<ICustomer[]>([])

  const [isPrivateVoucherAdd, setIsPrivateVoucherAdd] = useState<boolean>(false)

  // dk chọn nhóm
  const [infoIdGroupCustomer, setInfoIdGroupCustomer] = useState<IGroupCampaign[]>([])



  //

  //dk
  const [isAutoCondition, setIsAutoCondition] = useState(false)
  const [isModalLoadingSync, setIsModalLoadingSync] = useState<boolean>(false)

  const [infoOperator, setInfoOperator] = useState<IVConditionFilterCampaim>(initInfoOperator)
  //

  // kh k co dk

  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReactGroup(
      ColumnsMapShow, dataFieldsActive, undefined
    );
  }, [ColumnsMapShow]);

  //dk all
  const tableDataMatchedCustomers: any[] = useMemo(() => {
    return listMatchedCustomers.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
        acc[field.fieldCode] = field.view ? field.value : NO_VIEW
        return acc
      }, {})
      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      }
    })
  }, [listMatchedCustomers])

  const tableDataUnmatchedCustomers: any[] = useMemo(() => {
    return listUnmatchedCustomers.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
        acc[field.fieldCode] = field.view ? field.value : NO_VIEW
        return acc
      }, {})
      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      }
    })
  }, [listUnmatchedCustomers])


  const gSLTarget = async () => {
    const result = await getListTarget()
    if (result?.status) {
      setSLTarget(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const gSLNetwork = async () => {
    const result = await getListNetwork()
    if (result?.status) {
      setSLNetwork(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const gListFieldsActive = async () => {
    const result = await getListFieldsByCustomer(FIELDTYPE.CUSTOMER, 1)
    if (result?.status) {
      const flattenedFields = result.data.flatMap(choice =>
        choice.fields.map(field => ({
          ...field,
          parentId: choice.id,
        }))
      );
      setDataFieldsActive(flattenedFields)
      gListFieldsNotActive()
    }
  }

  const gListFieldsNotActive = async () => {
    const result = await getListFieldsByCustomer(FIELDTYPE.CUSTOMER, 0)
    if (result?.status) {
      setDataFieldsNoActive(result.data)
    }
  }




  //#region  Chọn nhóm kh api
  const gListCustomersByGroups = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    const { listCategoryCar, listUnit, search } = dataFilterMatchedCustomers
    const groupCustomerSelectedTmp = groupCustomerSelected?.map(i => i.id) || []
    const selectedIdUnmatchedCustomersTmp = Array.from(selectedIdUnmatchedCustomers)
    const voucherIdTmp = voucherTitle?.value

    setLoadingTable(true)
    const result = await getListCustomersByGroups(
      groupCustomerSelectedTmp,
      pageSize, pageCurent, unitTemp, listUnit,
      listCategoryCar, search, selectedIdUnmatchedCustomersTmp, undefined,
      voucherIdTmp
    )
    if (result?.status) {
      setListMatchedCustomers(result.data.customersFinal)
      setInfoCampaign({ ...infoCampaign, groupCustomerId: result.data.groups })

      setPaginationMatchedCustomers({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 1000)

  const gListCustomersUnmatchedByGroups = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    const { listCategoryCar, listUnit, search } = dataFilterUnmatchedCustomers
    const selectId = groupCustomerSelected?.map(i => i.id) || []
    pushLoading(true)

    const result = await getListCustomersUnmatchedByGroups(
      selectId,
      pageSize, pageCurent, unitTemp, listUnit,
      listCategoryCar, search
    )
    if (result?.status) {
      setListUnmatchedCustomers(result.data)
      setPaginationUnmatchedCustomers({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const gListALLCustomerIdByGroupAndUser = useDebounce(async () => {
    // phải trùng groupIds với gListCustomersByGroups để Preview và data lưu khớp nhau
    const selectId = groupCustomerSelected?.map(i => i.id) || []
    const voucherIdTmp = voucherTitle?.value

    pushLoading(true)
    const result = await getListALLCustomerIdByGroupAndUser(
      selectId,
      undefined, undefined, voucherIdTmp
    )
    if (result?.status) {
      setSelectedIdCustomer(result.data)
      // setSelectedIdUnmatchedCustomers(new Set())
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)
  //#endregion


  //#region dk nhom api
  // lấy list All
  const gListAllCustomers = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    setLoadingTable(true)

    const {
      listCategoryCar, listUnit, search
    } = dataFilterUnmatchedCustomers

    const lastIdTmp = pageCurent === 1 ? undefined : lastId

    const result = await getListCustomerByGroup(
      permittedCategoryCarIds,
      pageSize, pageCurent, search, unitTemp ?? undefined,
      listUnit, listCategoryCar, undefined, undefined,
      undefined, undefined, lastIdTmp?.noCond
    )
    if (result?.status) {
      setListMatchedCustomers(result.data)
      setPaginationMatchedCustomers({ current: pageCurent, total: result.total, pageSize })

      setLastId({ ...lastId, noCond: getLastIdList(result.data) })
    } else {
      // pushToast(result?.message, "warning")
    }
    setLoadingTable(false)

  }, 1000)


  const gIdSelectAllCustomer = useDebounce(async (isAllCond: boolean = true) => {
    pushLoading(true)

    //ds kh có dk lấy hết
    const conditions = isAllCond ? undefined : filterInfoOperatoToConditions(infoOperator)
    const result = await getListAllCustomer(
      permittedCategoryCarIds,
      unitTemp, conditions, undefined, undefined
    )
    if (result?.status) {
      setSelectedIdCustomer(result.data);
      setSqlTotal(result.sqlTotal)
    }

    pushLoading(false)
  }, 1000)

  //Lấy ra toàn bộ api thảo và k thỏa dk xem trước dk
  const gSyncListCustomerGroupByFilter = useDebounce(async (
    typeConditionPreview: TypeConditionPreview, pageCurent: number = 1, pageSize: number = 20
  ) => {


    setIsModalLoadingSync(true)
    const conditions = filterInfoOperatoToConditions(infoOperator)
    const listUnmatchedCustomers =
      (typeConditionPreview !== "filter" || !skipCondMatchedRef.current) ?
        Array.from(selectedIdUnmatchedCustomers) :
        undefined
    const dataFilter = typeConditionPreview === "condUnmatched" ? dataFilterUnmatchedCustomers : dataFilterMatchedCustomers;

    const lastIdTmp = pageCurent === 1 ? undefined : lastId

    switch (typeConditionPreview) {
      case "filter": {
        // const [resultFilterCondMatched, resultFilterCondUnMatched] = await Promise.all([
        //     getListConditionMatched(
        //         permittedCategoryCarIds, conditions,
        //         pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
        //         undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
        //         lastIdTmp?.condMatched
        //     ),
        //     getListConditionUnMatched(
        //         permittedCategoryCarIds, conditions,
        //         pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
        //         undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
        //         lastIdTmp?.condUnmatched
        //     )
        // ])

        const [resultFilterCondMatched] = await Promise.all([
          getListConditionMatched(
            permittedCategoryCarIds, conditions,
            pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
            undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
            lastIdTmp?.condMatched
          ),
          // getListConditionUnMatched(
          //     permittedCategoryCarIds, conditions,
          //     pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
          //     undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
          //     lastIdTmp?.condUnmatched
          // )
        ])

        if (resultFilterCondMatched.status) {
          setListMatchedCustomers(resultFilterCondMatched.data.dataMatched)
          setPaginationMatchedCustomers({ current: pageCurent, total: resultFilterCondMatched.data.totalMatched, pageSize })
        } else {
          pushToast(resultFilterCondMatched?.message, 'warning')
        }

        // if (resultFilterCondUnMatched.status) {
        //     setListUnmatchedCustomers(resultFilterCondUnMatched.data.dataUnmatched)
        //     setPaginationUnmatchedCustomers({ current: pageCurent, total: resultFilterCondUnMatched.data.totalUnmatched, pageSize })

        // } else {
        //     pushToast(resultFilterCondUnMatched?.message, 'warning')
        // }

        setLastId({
          ...lastId,
          condMatched: getLastIdList(resultFilterCondMatched.data.dataMatched),
          // condUnmatched: getLastIdList(resultFilterCondUnMatched.data.dataUnmatched)
        })

        break;
      }
      case "condMatched": {
        const resultFilterCondMatched = await getListConditionMatched(
          permittedCategoryCarIds,
          conditions,
          pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
          undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
          lastIdTmp?.condMatched
        )
        if (resultFilterCondMatched.status) {
          setListMatchedCustomers(resultFilterCondMatched.data.dataMatched)
          setPaginationMatchedCustomers({ current: pageCurent, total: resultFilterCondMatched.data.totalMatched, pageSize })

          setLastId({ ...lastId, condMatched: getLastIdList(resultFilterCondMatched.data.dataMatched) })
        } else {
          pushToast(resultFilterCondMatched?.message, 'warning')
        }
        break;
      }
      case "condUnmatched": {
        // const resultFilterCondUnMatched = await getListConditionUnMatched(
        //     permittedCategoryCarIds, conditions,
        //     pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
        //     undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
        //     lastIdTmp?.condUnmatched
        // )
        // if (resultFilterCondUnMatched.status) {
        //     setListUnmatchedCustomers(resultFilterCondUnMatched.data.dataUnmatched)
        //     setPaginationUnmatchedCustomers({ current: pageCurent, total: resultFilterCondUnMatched.data.totalUnmatched, pageSize })

        //     setLastId({ ...lastId, condUnmatched: getLastIdList(resultFilterCondUnMatched.data.dataUnmatched) })
        // } else {
        //     pushToast(resultFilterCondUnMatched?.message, 'warning')
        // }
        break;
      }

      default:
        break;
    }

    // Tắt cờ sau khi filter tải xong
    skipCondMatchedRef.current = false;
    setIsModalLoadingSync(false)
  }, 500)

  //#endregion

  const onChangeStep = (value: CampaignStep) => {
    if (value === CampaignStep.SETUP_INFO) {


    } else {
      if (isAutoCondition) {
        const infoOperatorApply = filterInfoOperator(infoOperator)
        if (infoOperatorApply.conditions.length < 1 && infoOperatorApply.typeCondition !== CONDITIONGROUP.ALL) {
          pushToast("Chưa có điêu kiện nào được chọn!", 'warning')
          return
        }
      }
      childRef.current?.changeStepPreview()
    }
  };

  const handleSwitch = (value: boolean) => {
    setDataFilterMatchedCustomers(dataDefaulFilterList)
    setIsAutoCondition(value)
    if (value) {
      setInfoIdGroupCustomer([])
    } else {
      setInfoOperator(initInfoOperator)
    }
  }


  //#region Chọn kh thỏa và không

  //Kh có dk ds xem trước
  const handleChangeCondSelectIdCustomerView: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>> = (value) => {
    // Chuẩn hoá về mảng ISelectedCustomer[]
    const nextArray =
      typeof value === 'function'
        ? value(selectedIdCustomer) // selectedIdCustomerV9: state hiện tại
        : value;

    // Lấy danh sách customerId từ mảng value
    const valueIds = new Set(nextArray.map(v => v.customerId));

    // Giả sử selectedIdNoCondCustomerManual vẫn là Set<number>
    const nextB = new Set(
      [...selectedIdUnmatchedCustomers].filter(x => valueIds.has(x))
    );

    // Cập nhật state chính
    setSelectedIdCustomer(value);

    // Kiểm tra hai Set có giống nhau không
    const areSetsEqual =
      selectedIdUnmatchedCustomers.size === nextB.size &&
      [...selectedIdUnmatchedCustomers].every(v => nextB.has(v));

    if (!areSetsEqual) {
      setSelectedIdUnmatchedCustomers(nextB);
    }
  }

  //Kh có dk

  const handleChangeCondSelectIdCustomerManual = (value: Set<number>) => {
    // 1) Cập nhật danh sách selectedIdCustomerV9 (thêm + xóa theo diff)
    setSelectedIdCustomer(prevList => {
      // Tìm các id bị bỏ chọn (có trong selectedIdUnmatchedCustomers nhưng không còn trong value)
      const removedIds = new Set<number>();
      selectedIdUnmatchedCustomers.forEach(id => {
        if (!value.has(id)) removedIds.add(id);
      });

      // a) XÓA: loại bỏ các item Manual có customerId thuộc removedIds
      const kept = prevList.filter(item => {
        // nếu bị bỏ chọn -> loại
        if (removedIds.has(item.customerId)) return false;
        return true; // còn lại giữ
      });

      // b) THÊM: thêm các id mới từ value nếu chưa có trong kept
      const byId = new Map<number, ISelectedCustomer>(kept.map(c => [c.customerId, c]));
      value.forEach(id => {
        if (!byId.has(id)) {
          byId.set(id, { customerId: id, addType: AddType.Manual });
        }
      });

      return Array.from(byId.values());
    });

    // 2) Đồng bộ lại "bộ chọn" unmatched hiện tại
    setSelectedIdUnmatchedCustomers(value);
  };
  //#endregion

  //Kh có dk
  const onPaginationMatchedCustomers: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    if (isAutoCondition) {
      if (infoOperator.typeCondition === CONDITIONGROUP.ALL) {
        gListAllCustomers(pageNumber, pageSize)
      }
      else {
        gSyncListCustomerGroupByFilter("condMatched", pageNumber, pageSize)
      }
    } else {
      gListCustomersByGroups(pageNumber, pageSize)
    }

  }


  // phần ni pagination cho modal thêm khách hàngngf
  const onPaginationUnmatchedCustomers: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    if (isAutoCondition) {
      if (infoOperator.typeCondition === CONDITIONGROUP.ALL) {
        gListAllCustomers(pageNumber, pageSize)
      }
      else {
        gSyncListCustomerGroupByFilter("condMatched", pageNumber, pageSize)
      }
    } else {
      gListCustomersUnmatchedByGroups(pageNumber, pageSize)
    }

  }

  // add KH riêng
  // const addCustomersInChunks = async (selectedIdCustomerV9: ISelectedCustomer[], idGroup: number) => {
  //   for (let i = 0; i < selectedIdCustomerV9.length; i += BATCH_SIZE) {
  //     const chunk = selectedIdCustomerV9.slice(i, i + BATCH_SIZE);

  //     await addCustomerCampaign(idGroup, chunk); // gọi API từng batch

  //     await new Promise(r => setTimeout(r, 50)); // tránh nghẽn
  //     // console.log('Processed chunk:', i)
  //   }
  // };

  const addCustomersInChunks = async (selectedIdCustomerV9: ISelectedCustomer[], idGroup: number) => {
    for (let i = 0; i < selectedIdCustomerV9.length; i += BATCH_SIZE) {
      const chunk = selectedIdCustomerV9.slice(i, i + BATCH_SIZE);

      let success = false;
      let retryCount = 0;

      while (!success) {
        try {
          await addCustomerCampaign(idGroup, chunk);
          success = true;
        } catch (error) {
          retryCount++;
          console.error(`Chunk ${i / BATCH_SIZE + 1} failed (retry ${retryCount})`, error);

          // delay trước khi retry
          await new Promise(r => setTimeout(r, 1000));
        }
      }

      // delay giữa các batch
      await new Promise(r => setTimeout(r, 50));
    }
  };

  const onFinish = useThrottle(async () => {
    const {
      title, targetId, channelList, type,
      role, auto,
      groupCustomerId, dateSend, timeSend,
      sendEvent, sendInAdvance, sendHour, description
    } = infoCampaign ?? {}

    if (!title || targetId === undefined || type === undefined || role === undefined) {
      pushToast("Thiếu thông tin campaign", "warning");
      return;
    }

    const channelListTmp: IChannelListV9[] =
      channelList?.map(item => ({
        channelId: item.channelId,
        brandId: item.brandId ?? 0,
        notificationTemplateId: item.notificationTemplateId ?? 0,
      })) ?? [];

    const autoTmp = isAutoCondition ? 1 : 0
    const timeSendTmp = timeSend ?? sendHour

    const filteredInfoOperatorADD = toAddPayload(infoOperator)

    // const listFilterGroup: IVConditionFilterADD = {
    //   typeCondition: filteredInfoOperatorADD.typeCondition,
    //   conditions: filteredInfoOperatorADD.conditions
    // };

    const listFilterGroup: IVConditionFilterADD = {
      typeCondition: filteredInfoOperatorADD.typeCondition,

      conditions: filteredInfoOperatorADD.conditions.map(condition => ({
        ...condition,

        value: convertDateValue(condition.value),
      })),
    };

    const voucherId = voucherTitle?.value

    pushLoading(true)

    const result = await addCampaign(
      title, id, targetId, channelListTmp,
      type, role, autoTmp,
      // selectedIdCustomer, groupCustomerId, dateSend, timeSendTmp,
      groupCustomerId, dateSend, timeSendTmp,
      sendEvent, sendInAdvance, listFilterGroup, description,
      voucherId
    )
    if (result?.status) {
      pushToast(result?.message, "success")

      // Voucher cá nhân: đồng bộ lại danh sách customer ID trước khi lưu,
      // tránh phụ thuộc state đã bị reset/debounce
      let customersToAdd = selectedIdCustomer
      if (voucherId && !isAutoCondition) {
        const groupIdsTmp = groupCustomerSelected?.map(i => i.id) || []
        const resultIds = await getListALLCustomerIdByGroupAndUser(
          groupIdsTmp, undefined, undefined, voucherId
        )
        if (resultIds?.status && resultIds.data?.length) {
          customersToAdd = resultIds.data
        }
      }
      if (!isPrivateVoucherAdd) {
        await addCustomersInChunks(
          customersToAdd, result.data.id
        )
      }
      await sendInstantlyCampaign(result.data.id);

      navigate(-1)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 5000)

  useEffect(() => {
    const codes = dataFieldsActive.map(f => f.fieldCode)
    setColumnsMapShow(codes)
  }, [dataFieldsActive])


  //#region  Kh có dk useEffect

  //Kh có dk khi thêm tự động
  useEffect(() => {
    const hasAppliedConditions = infoOperator.conditions.some(c => c.isAdd === true)

    if (isAutoCondition && !hasAppliedConditions) {
      // Chưa có điều kiện → dùng API + filter của thủ công
      gListCustomersByGroups()
    } else if (isAutoCondition) {
      if (infoOperator.typeCondition === CONDITIONGROUP.ALL) {
        gListAllCustomers()
      } else {
        setIsModalLoadingSync(true)
        gSyncListCustomerGroupByFilter("condMatched")
      }
    } else {
      gListCustomersByGroups()
    }
  }, [dataFilterMatchedCustomers])

  //Kh có dk khi thêm tự động
  useEffect(() => {
    if (isAutoCondition) {
      setIsModalLoadingSync(true)
      gSyncListCustomerGroupByFilter("condUnmatched")
    } else {
      if (groupCustomerSelected.length) {
        gListCustomersUnmatchedByGroups()
      }
    }
  }, [dataFilterUnmatchedCustomers])

  //Kh có dk khi thêm thủ công
  useEffect(() => {
    if (skipCondMatchedRef.current) return;
    if (isAutoCondition) {
      setIsModalLoadingSync(true)
      gSyncListCustomerGroupByFilter("condMatched")
    } else {
      gListCustomersByGroups()
    }
  }, [selectedIdUnmatchedCustomers])

  //kh có dk khi bật tắt tự động thêm đk clear data
  useEffect(() => {
    const hasAppliedConditions = infoOperator.conditions.some(c => c.isAdd === true)

    // Nếu switch sang auto mà chưa có điều kiện nào được áp dụng
    // → giữ nguyên table, data, filter của thủ công, không clear gì cả
    if (isAutoCondition && !hasAppliedConditions) return

    setSqlTotal(undefined)
    setSelectedIdCustomer([])
    setSelectedIdUnmatchedCustomers(new Set())
    setGroupCustomerSelected([])
    setInfoCampaign({ ...infoCampaign, groupCustomerId: undefined })

    // Clear table khi switch mode — tránh hiển thị data của mode cũ
    setListMatchedCustomers([])
    setListUnmatchedCustomers([])
    setPaginationMatchedCustomers({ current: 1, pageSize: 30, total: 0 })
    setPaginationUnmatchedCustomers({ current: 1, pageSize: 30, total: 0 })

    if (!isAutoCondition)
      setInfoOperator(initInfoOperator)
  }, [isAutoCondition])

  //Kh có dk  thay đổi dk
  useEffect(() => {
    // bất tắt switch áp dụng điều kiện
    const conditions = infoOperator.conditions.filter((a) => a.isAdd === true)
    // hàm xử lý khi thay đổi đk thành AND - OR
    if (conditions.length) {
      setIsModalLoadingSync(true)

      // Bật cờ để không cho A tự động bắn condMatched do reset
      skipCondMatchedRef.current = true;

      //Xóa các trường đã chọn khi thay đổi đk
      //Xóa các trường đã chọn khi thay đổi đk
      setSqlTotal(undefined)
      setSelectedIdCustomer([])
      setSelectedIdUnmatchedCustomers(new Set())

      gSyncListCustomerGroupByFilter("filter")
      gIdSelectAllCustomer(false)
    }
  }, [infoOperator.conditions])

  // gọi api lấy all
  useEffect(() => {
    if (infoOperator.typeCondition === CONDITIONGROUP.ALL) {
      gIdSelectAllCustomer()
      gListAllCustomers()
    }
  }, [unitTemp, infoOperator.typeCondition])
  //#endregion

  //#region  Chọn nhóm kh useEffect thay đổi nhóm và thêm khi chọn voucher
  useEffect(() => {

    setDataFilterMatchedCustomers(dataDefaulFilterList)
    setDataFilterUnmatchedCustomers(dataDefaulFilterList)

    setPaginationMatchedCustomers({ current: 1, pageSize: 30, total: 0 })
    setPaginationUnmatchedCustomers({ current: 1, pageSize: 30, total: 0 })

    setSqlTotal(undefined)
    setSelectedIdCustomer([])
    setSelectedIdUnmatchedCustomers(new Set())


    if (groupCustomerSelected.length || voucherTitle?.value) {
      gListALLCustomerIdByGroupAndUser()
      gListCustomersUnmatchedByGroups()
    } else {



      setListMatchedCustomers([])
      setListUnmatchedCustomers([])

      setInfoCampaign({ ...infoCampaign, groupCustomerId: undefined })
    }
  }, [groupCustomerSelected, voucherTitle])

  useEffect(() => {
    if (!isAutoCondition) {
      gListCustomersByGroups()
    }
  }, [dataFilterMatchedCustomers, groupCustomerSelected, voucherTitle])
  //#endregion


  //#region: location
  useEffect(() => {
    setIsAutoCondition(isAutoCampaign)
  }, [isAutoCampaign])
  //#endregion
  return (
    <GroupContext.Provider
      value={{
        step, voucherTitle,
        ColumnsMapShow, dataFieldsActive,
        sLCategoryCar, sLNationwide, sLTarget,
        setVoucherTitle

      }}>
      <Layout contentClassName='customer-add-content'>


        <BreadcrumbBlockAdd
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: <Link to="/marketing/campaign-sends-notifications">Marketing</Link>, },
            { title: <Link to="/marketing/campaign-sends-notifications">Chiến dịch gửi thông báo</Link>, },
            { title: 'Thêm mới chiến dịch', },
          ]}
          className="gutter-block-end"
        />
        <div className="app-breadcrumb-title">

          <Link
            className="icon"
            to={'/marketing/campaign-sends-notifications'}
          >
            <ArrowLeftOutlined />
          </Link>

          <div className="title">Tạo mới chiến dịch</div>
          {
            step === CampaignStep.SETUP_INFO ?
              <button
                className={
                  `custom-page-css ml-auto rounded bg-096DD9 text-white border-1890FF py-2 px-4`
                }
                onClick={() => onChangeStep(CampaignStep.PREVIEW)}
              >
                Tiếp theo
              </button> :
              <button
                className="custom-page-css ml-auto rounded bg-096DD9 text-white border-1890FF py-2 px-4"
                onClick={() => onFinish()}
              >
                Lưu
              </button>
          }

        </div>
        <div className="custom-page-css w-full flex items-center justify-center ">
          <div className="custom-page-css w-50-percent">
            <Steps
              current={step}
              onChange={onChangeStep}
              items={[
                {
                  title: 'Thiết lập thông tin',
                  onClick: () => setStep(CampaignStep.SETUP_INFO)
                },
                {
                  title: 'Xem trước chiến dịch',
                }
              ]}
              size="small"
              className="custom-steps"
            />
          </div>

        </div>

        <div className={step === CampaignStep.SETUP_INFO ? '' : 'd-none'}>
          <div className="custom-page-css flex gap-2 pt-4">
            <div className={`${isAutoCondition ? 'border' : 'text-1890FF border-91D5FF'} custom-page-css w-1-2 flex items-center justify-center gap-2 py-1  rounded cursor-pointer`}
              // onClick={() => handleSwitch(false)}
              onClick={() => {
                if (step === CampaignStep.SETUP_INFO) {
                  handleSwitch(false);
                }
              }}
            >
              <img src={isAutoCondition ? User : User_active} alt="" />
              <span>Chiến dịch thủ công</span>
            </div>
            <div className={`${!isAutoCondition ? 'border' : 'text-1890FF border-91D5FF'} custom-page-css w-1-2 flex items-center justify-center gap-2 py-1 rounded cursor-pointer`}
              // onClick={() => handleSwitch(true)}
              onClick={() => {
                if (step === CampaignStep.SETUP_INFO) {
                  handleSwitch(true);
                }
              }}
            >
              <img src={isAutoCondition ? auto_icon_active : auto_icon} alt="" />
              <span>Chiến dịch tự động</span>
            </div>
          </div>
        </div>
        {/* <div className="custom-page-css flex items-center justify-end gap-2 pt-4">
                    <span className='custom-page-css font-medium lh-24 fsz-16 font-regular whiteSpace-nowrap'>Tự động thêm khách hàng có cùng điều kiện</span>
                    <Switch
                        checked={isAutoCondition}
                        onClick={() => handleSwitch(!isAutoCondition)}
                    />
                </div> */}

        <div className={step === CampaignStep.SETUP_INFO ? '' : 'd-none'}>
          <InfoCreate
            ref={childRef}

            sLTarget={sLTarget}
            sLNetwork={sLNetwork}
            loading={loadingTable}

            memoizedColumnDefs={memoizedColumnDefs}

            infoCampaign={infoCampaign}

            groupCustomerSelected={groupCustomerSelected}
            selectedIdCustomer={selectedIdCustomer}
            selectedIdUnmatchedCustomers={selectedIdUnmatchedCustomers}

            dataFilterMatchedCustomers={dataFilterMatchedCustomers}
            dataFilterUnmatchedCustomers={dataFilterUnmatchedCustomers}
            paginationMatchedCustomers={paginationMatchedCustomers}
            paginationUnmatchedCustomers={paginationUnmatchedCustomers}

            listMatchedCustomers={tableDataMatchedCustomers}
            listUnmatchedCustomers={tableDataUnmatchedCustomers}

            setStep={setStep}
            setIsPrivateVoucherAdd={setIsPrivateVoucherAdd}
            setInfoCampaign={setInfoCampaign}
            setGroupCustomerSelected={setGroupCustomerSelected}
            setSelectedIdCustomer={handleChangeCondSelectIdCustomerView}
            setSelectedIdUnmatchedCustomers={handleChangeCondSelectIdCustomerManual}

            setDataFilterMatchedCustomers={setDataFilterMatchedCustomers}
            setDataFilterUnmatchedCustomers={setDataFilterUnmatchedCustomers}

            onPaginationMatchedCustomers={onPaginationMatchedCustomers}
            onPaginationUnmatchedCustomers={onPaginationUnmatchedCustomers}

            //dk
            isAutoCondition={isAutoCondition}
            infoOperator={infoOperator}
            setInfoOperator={setInfoOperator}

          //


          />
        </div>
        <div className={step === CampaignStep.PREVIEW ? '' : 'd-none'}>
          <PreView

            memoizedColumnDefs={memoizedColumnDefs}

            loading={loadingTable}

            infoCampaign={infoCampaign}
            sqlTotal={sqlTotal}
            listMatchedCustomers={tableDataMatchedCustomers}
            dataFilterMatchedCustomers={dataFilterMatchedCustomers}

            paginationMatchedCustomers={paginationMatchedCustomers}

            setDataFilterMatchedCustomers={setDataFilterMatchedCustomers}

            onPaginationMatchedCustomers={onPaginationMatchedCustomers}
            infoOperator={infoOperator}
            selectedIdCustomer={selectedIdCustomer}
          />
        </div>

      </Layout>
    </GroupContext.Provider>
  )
}

export default CreateAnnouncementCampaign
export const useCustomerGroupContext = () => useContext(GroupContext)!;
